// Legacy exports (backward compatibility)
export { authApi } from './shared/auth/api';
export { leadsApi } from './shared/leads/api';
export { walletApi } from './shared/wallet/api';
export type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
} from './shared/auth/types';
export type {
  CreateLeadRequest,
  Lead,
  CreateLeadResponse,
  GetLeadResponse,
  GetLeadsResponse,
  TenantSearchResult,
  SearchTenantsResponse,
} from './shared/leads/types';
export type {
  Wallet,
  CreateWalletRequest,
  UpdateBalanceRequest,
  UpdatePendingBalanceRequest,
  WalletResponse,
  DepositRequest,
  DepositRequestWithFile,
  DepositTransaction,
  CreateDepositResponse,
  DepositListResponse,
  ApproveRejectRequest,
  ApproveRejectResponse,
  PaymentProofImageData,
  PaymentProofUrlResponse,
  AdminDepositFilters,
  AdminDepositTransaction,
  AdminDepositsResponse,
  AdminDepositsListResponse,
  DepositStats,
  DepositStatsResponse,
} from './shared/wallet/types';
export { apiClient } from './shared/apiClient';

// Admin SDK exports
export { adminAuthApi } from './admin/features/auth/api';
export { adminWalletApi } from './admin/features/wallet/api';
export { adminKycApi } from './admin/features/kyc/api';
export { adminUsersApi, getUsers, getUserById, getDashboardStats, registerUser, updateUser, resetUserPassword, deleteUser } from './admin/features/users/api';
export { useUsers } from './admin/features/users/hooks/useUsers';

// Client SDK exports
export { clientAuthApi } from './client/features/auth/api';
export { clientWalletApi } from './client/features/wallet/api';
export { clientKycApi } from './client/features/kyc/api';
export { useKyc } from './client/features/kyc/hooks/useKyc';
export { clientProfileApi } from './client/features/profile/api';
export { useProfile } from './client/features/profile/hooks/useProfile';

// Admin types (prefixed to avoid conflicts)
export type {
  AdminLoginRequest,
} from './admin/features/auth/types';

export type {
  PendingDocument,
  DocumentFilters,
  AdminDocumentsResponse,
  KYCStatistics,
  DocumentReviewResponse,
} from './admin/features/kyc/types';

export type {
  User as AdminUser,
  UserRole,
  UserStatus,
  UsersListResponse,
  UserFilters,
  DashboardStats,
} from './admin/features/users/types';

// Client types (prefixed to avoid conflicts)
export type {
  ClientLoginRequest,
  ClientLoginResponse,
  ClientRegisterRequest,
  ClientRegisterResponse,
} from './client/features/auth/types';

export type {
  KYCDocument as ClientKYCDocument,
  ClientKYCStatusResponse,
  KYCStatus,
} from './client/features/kyc/types';

export type {
  ClientProfile,
  WalletInfo as ClientWalletInfo,
  TradingAccount as ClientTradingAccount,
  KycDocument as ClientKycDocument,
  FullProfileResponse,
  UpdateProfileRequest,
  UpdateProfileResponse,
} from './client/features/profile/types';

export { clientTransactionsApi } from './client/features/transactions/api';
export { useTransactions } from './client/features/transactions/hooks/useTransactions';
export { useTransactionsStats } from './client/features/transactions/hooks/useTransactionsStats';

export type {
  ClientTransaction,
  ClientTransactionsResponse,
  ClientTransactionsAPIResponse,
  FetchTransactionsParams as ClientFetchTransactionsParams,
  ClientTransactionsStats,
} from './client/features/transactions/types';

// Downloads feature exports
export { clientDownloadsApi } from './client/features/downloads/api';
export { useDownloads } from './client/features/downloads/hooks/useDownloads';
export type {
  ApplicationDownload,
  DownloadsListResponse,
} from './client/features/downloads/types';

export { adminDownloadsApi } from './admin/features/downloads/api';
export { useAdminDownloads } from './admin/features/downloads/hooks/useAdminDownloads';
export type {
  CreateDownloadRequest,
  UpdateDownloadRequest,
  AdminDownloadResponse,
  AdminDownloadsListResponse,
} from './admin/features/downloads/types';